import App from "@/views/App.vue";

export default [
  {
    path: "/lounge",
    name: "community",
    component: App,
    redirect: { name: "communityHome" },
    children: [
      {
        path: "/lounge/:id",
        name: "communityHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Community.vue"),
        meta: {
          displayName: "displayName.communityHome",
          requiresAuth: true,
        },
      },
      {
        path: "/lounge/membros/:id",
        name: "communityMembersHome",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/CommunityMembers.vue"
          ),
        meta: {
          displayName: "displayName.communityMembers",
          requiresAuth: true,
        },
      },
      {
        path: "/meus-lounges",
        name: "profileCommunity",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/CommunityList.vue"),
        meta: {
          displayName: "displayName.myLounges",
          requiresAuth: true,
        },
      },
      {
        path: "/novo-lounge",
        name: "newLounge",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewLounge.vue"),
        meta: {
          displayName: "displayName.newLounge",
          requiresAuth: true,
        },
      },
      {
        path: "/editar-lounge/:id",
        name: "editLounge",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditLounge.vue"),
        meta: {
          displayName: "displayName.editLounge",
          requiresAuth: true,
        },
      },
      {
        path: "/convidar-membros-lounge/:id",
        name: "inviteNewMembers",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/InviteNewMembers.vue"
          ),
        meta: {
          displayName: "displayName.inviteMembers",
          requiresAuth: true,
        },
      },
    ],
  },
];
